module.exports = __webpack_public_path__ + "img/ic-close-white.c4b14057.svg";